import { createGlobalStyle, css } from 'styled-components';

const HelperClass = createGlobalStyle`${css`
	//! Colors & Backgrounds
	.primaryColor1 {
		color: var(--primaryColor1);

		&-bg {
			background: var(--primaryColor1);
		}
	}

	.primaryColor2 {
		color: var(--primaryColor2);

		&-bg {
			background: var(--primaryColor2);
		}
	}

	.primaryColor3 {
		color: var(--primaryColor3);

		&-bg {
			background: var(--primaryColor3);
		}
	}

	.secondaryColor1 {
		color: var(--secondaryColor1);

		&-bg {
			background: var(--secondaryColor1);
		}
	}

	.secondaryColor2 {
		color: var(--secondaryColor2);

		&-bg {
			background: var(--secondaryColor2);
		}
	}

	.secondaryColor3 {
		color: var(--secondaryColor3);

		&-bg {
			background: var(--secondaryColor3);
		}
	}

	.secondaryColor4 {
		color: var(--secondaryColor4);

		&-bg {
			background: var(--secondaryColor4);
		}
	}

	.secondaryColor5 {
		color: var(--secondaryColor5);

		&-bg {
			background: var(--secondaryColor5);
		}
	}

	.successColor {
		color: var(--successColor) !important;

		&-bg {
			background: var(--successColor) !important;
		}
	}

	.errorColor {
		color: var(--errorColor) !important;

		&-bg {
			background: var(--errorColor) !important;
		}
	}

	//! Only Backgrounds
	.bgBigStone {
		background: var(--bgBigStone);
		color: var(--primaryColor3);

		&-hover:hover {
			@media (hover: hover) {
				background: var(--bgBigStone);
				transition: background var(--trTime);
			}
		}

		&-text {
			color: var(--bgBigStone);
		}
	}

	.bgApricot {
		background: var(--bgApricot);
		color: var(--primaryColor3);

		&-hover:hover {
			@media (hover: hover) {
				background: var(--bgApricot);
				transition: background var(--trTime);
			}
		}

		&-text {
			color: var(--bgApricot);
		}
	}

	.bgCobalt {
		background: var(--bgCobalt);
		color: var(--primaryColor3);

		&-hover:hover {
			@media (hover: hover) {
				background: var(--bgCobalt);
				transition: background var(--trTime);
			}
		}

		&-text {
			color: var(--bgCobalt);
		}
	}

	.bgYellowTan {
		background: var(--bgYellowTan);
		color: var(--bgBlackPearl);

		&-hover:hover {
			@media (hover: hover) {
				background: var(--bgYellowTan);
				transition: background var(--trTime);
			}
		}

		&-text {
			color: var(--bgYellowTan);
		}
	}

	.bgBrightMaroon {
		background: var(--bgBrightMaroon);
		color: var(--primaryColor3);

		&-hover:hover {
			@media (hover: hover) {
				background: var(--bgBrightMaroon);
				transition: background var(--trTime);
			}
		}

		&-text {
			color: var(--bgBrightMaroon);
		}
	}

	.bgWineBerry {
		background: var(--bgWineBerry);
		color: var(--primaryColor3);

		&-hover:hover {
			@media (hover: hover) {
				background: var(--bgWineBerry);
				transition: background var(--trTime);
			}
		}

		&-text {
			color: var(--bgWineBerry);
		}
	}

	.bgGreenPea {
		background: var(--bgGreenPea);
		color: var(--primaryColor3);

		&-hover:hover {
			@media (hover: hover) {
				background: var(--bgGreenPea);
				transition: background var(--trTime);
			}
		}

		&-text {
			color: var(--bgGreenPea);
		}
	}

	.bgMalibu {
		background: var(--bgMalibu);
		color: var(--bgBlackPearl);

		&-hover:hover {
			@media (hover: hover) {
				background: var(--bgMalibu);
				transition: background var(--trTime);
			}
		}

		&-text {
			color: var(--bgMalibu);
		}
	}

	.bgBlackPearl {
		background: var(--bgBlackPearl);
		color: var(--primaryColor3);

		&-hover:hover {
			@media (hover: hover) {
				background: var(--bgBlackPearl);
				transition: background var(--trTime);
			}
		}

		&-text {
			color: var(--bgBlackPearl);
		}
	}

	.bgPurpleHaze {
		background: var(--bgPurpleHaze);
		color: var(--primaryColor3);

		&-hover:hover {
			@media (hover: hover) {
				background: var(--bgPurpleHaze);
				transition: background var(--trTime);
			}
		}

		&-text {
			color: var(--bgPurpleHaze);
		}
	}

	.bgBegonia {
		background: var(--bgBegonia);
		color: var(--primaryColor3);

		&-hover:hover {
			@media (hover: hover) {
				background: var(--bgBegonia);
				transition: background var(--trTime);
			}
		}

		&-text {
			color: var(--bgBegonia);
		}
	}

	.bgCowBoy {
		background: var(--bgCowBoy);
		color: var(--primaryColor3);

		&-hover:hover {
			@media (hover: hover) {
				background: var(--bgCowBoy);
				transition: background var(--trTime);
			}
		}

		&-text {
			color: var(--bgCowBoy);
		}
	}

	.bgWhite {
		background: var(--primaryColor3);
		color: var(--bgBlackPearl);

		&-hover:hover {
			@media (hover: hover) {
				background: var(--primaryColor3);
				transition: background var(--trTime);
			}
		}

		&-text {
			color: var(--primaryColor3);
		}
	}

	.bgPearl {
		background: var(--bgPearl);
		color: var(--bgBlackPearl);

		&-hover:hover {
			@media (hover: hover) {
				background: var(--bgPearl);
				transition: background var(--trTime);
			}
		}

		&-text {
			color: var(--bgPearl);
		}
	}

	//! Only border
	.borderCobalt {
		border: 1px solid var(--bgCobalt) !important;
		background: transparent !important;
		color: var(--bgCobalt) !important;

		&-hover:hover {
			@media (hover: hover) {
				border: 1px solid var(--bgCobalt) !important;
				color: var(--bgCobalt) !important;
				background-color: transparent;
				transition: var(--trTime);
			}
		}

		&-text {
			color: var(--bgCobalt);
		}
	}

	.borderYellowTan {
		border: 1px solid var(--bgYellowTan) !important;
		background: transparent !important;
		color: var(--bgYellowTan) !important;

		&-hover:hover {
			@media (hover: hover) {
				border: 1px solid var(--bgYellowTan) !important;
				color: var(--bgYellowTan) !important;
				background-color: transparent;
				transition: var(--trTime);
			}
		}

		&-text {
			color: var(--bgYellowTan);
		}
	}

	.borderGreenPea {
		border: 1px solid var(--bgGreenPea) !important;
		background: transparent !important;
		color: var(--bgGreenPea) !important;

		&-hover:hover {
			@media (hover: hover) {
				border: 1px solid var(--bgGreenPea) !important;
				color: var(--bgGreenPea) !important;
				background-color: transparent;
				transition: var(--trTime);
			}
		}

		&-text {
			color: var(--bgGreenPea);
		}
	}

	.borderWineBerry {
		border: 1px solid var(--bgWineBerry) !important;
		background: transparent !important;
		color: var(--bgWineBerry) !important;

		&-hover:hover {
			@media (hover: hover) {
				border: 1px solid var(--bgWineBerry) !important;
				color: var(--bgWineBerry) !important;
				background-color: transparent;
				transition: var(--trTime);
			}
		}

		&-text {
			color: var(--bgWineBerry);
		}
	}

	.borderMalibu {
		border: 1px solid var(--bgMalibu) !important;
		background: transparent !important;
		color: var(--bgMalibu) !important;

		&-hover:hover {
			@media (hover: hover) {
				border: 1px solid var(--bgMalibu) !important;
				color: var(--bgMalibu) !important;
				background-color: transparent;
				transition: var(--trTime);
			}
		}

		&-text {
			color: var(--bgMalibu);
		}
	}

	.borderBlackPearl {
		border: 1px solid var(--bgBlackPearl) !important;
		background: transparent !important;
		color: var(--bgBlackPearl) !important;

		&-hover:hover {
			@media (hover: hover) {
				border: 1px solid var(--bgBlackPearl) !important;
				color: var(--bgBlackPearl) !important;
				background-color: transparent;
				transition: var(--trTime);
			}
		}

		&-text {
			color: var(--bgBlackPearl);
		}
	}

	.borderPurpleHaze {
		border: 1px solid var(--bgPurpleHaze) !important;
		background: transparent !important;
		color: var(--bgPurpleHaze) !important;

		&-hover:hover {
			@media (hover: hover) {
				border: 1px solid var(--bgPurpleHaze) !important;
				color: var(--bgPurpleHaze) !important;
				background-color: transparent;
				transition: var(--trTime);
			}
		}

		&-text {
			color: var(--bgPurpleHaze);
		}
	}

	.borderCowBoy {
		border: 1px solid var(--bgCowBoy) !important;
		background: transparent !important;
		color: var(--bgCowBoy) !important;

		&-hover:hover {
			@media (hover: hover) {
				border: 1px solid var(--bgCowBoy) !important;
				color: var(--bgCowBoy) !important;
				background-color: transparent;
				transition: var(--trTime);
			}
		}

		&-text {
			color: var(--bgCowBoy);
		}
	}

	.borderApricot {
		border: 1px solid var(--bgApricot) !important;
		background: transparent !important;
		color: var(--bgApricot) !important;

		&-hover:hover {
			@media (hover: hover) {
				border: 1px solid var(--bgApricot) !important;
				color: var(--bgApricot) !important;
				background-color: transparent;
				transition: var(--trTime);
			}
		}

		&-text {
			color: var(--bgApricot);
		}
	}

	.borderBegonia {
		border: 1px solid var(--bgBegonia) !important;
		background: transparent !important;
		color: var(--bgBegonia) !important;

		&-hover:hover {
			@media (hover: hover) {
				border: 1px solid var(--bgBegonia) !important;
				color: var(--bgBegonia) !important;
				background-color: transparent;
				transition: var(--trTime);
			}
		}

		&-text {
			color: var(--bgBegonia);
		}
	}

	//! Fonts
	.font-soundscape {
		font-family: var(--soundscape);

		&-medium {
			font-family: var(--soundscape);
			font-weight: 500 !important;
		}

		&-bold {
			font-family: var(--soundscape);
			font-weight: 700 !important;
		}
	}

	.lang-hy {
		.font-soundscape {
			font-family: var(--ping);
			/* font-weight: 400 !important; */
			font-weight: 700 !important;
		}

		.font-soundscape-medium {
			font-family: var(--ping);
			/* font-weight: 500 !important; */
			font-weight: 700 !important;
		}

		.font-soundscape-bold {
			font-family: var(--ping);
			/* font-weight: 600 !important; */
			font-weight: 700 !important;
		}
	}

	.font-helvetica {
		font-family: var(--helvetica);
		font-weight: 400 !important;

		&-bold {
			font-family: var(--helvetica);
			font-weight: 600 !important;
		}
	}

	.font-ping {
		font-family: var(--ping);

		&-medium {
			font-family: var(--ping);
			font-weight: 500 !important;
		}

		&-bold {
			font-family: var(--ping);
			font-weight: 600 !important;
		}

		&-bolder {
			font-family: var(--ping);
			font-weight: 700 !important;
		}
	}

	//! Text capitalize

	.uppercase {
		text-transform: uppercase;
	}

	.lowercase {
		text-transform: lowercase;
	}

	.capitalize {
		text-transform: capitalize;
	}

	.underline {
		text-decoration: underline;
	}

	.text-center {
		text-align: center;
	}

	.text-left {
		text-align: left;
	}

	.text-right {
		text-align: right;
	}

	//! Burger Icon

	.burger-icon {
		position: relative;
		display: inline-block;
		width: var(--burgerIconW);
		height: var(--burgerIconH);

		&:before,
		&:after {
			content: '';
			position: absolute;
			left: 0;
			right: 0;
			height: 2px;
			background: var(--primaryColor1);
			transform: translateY(-50%);
			transition: all var(--trTime);
		}

		&.light-bg {
			&:before,
			&:after {
				background: var(--secondaryColor1);
			}
		}

		&:before {
			top: 25%;
		}

		&:after {
			top: 75%;
		}

		&.active {
			&:after,
			&:before {
				top: 50%;
			}

			&:before {
				transform: translateY(-50%) rotate(45deg);
			}

			&:after {
				transform: translateY(-50%) rotate(-45deg);
			}
		}
	}

	//! Disabled
	.disabled {
		opacity: 0.5;
		pointer-events: none;
	}

	//! Hidden Container
	.hidden-container {
		overflow: hidden;
	}
`}`;

export default HelperClass;
